import React, { useState } from "react";
import {
  View,
  StyleSheet,
  TouchableWithoutFeedback
} from "react-native";
import Modal  from "react-native-modal";
import { MaterialCommunityIcons, 
    AntDesign, 
    Fontisto, 
    Octicons, 
    FontAwesome5, 
    Entypo  } from "@expo/vector-icons";

import defaultStyles from "../config/styles";
import PickerItem from "../components/PickerItem";
import Button from "../components/Button";
import Text from "../components/Text";
import colors from "../config/colors";
import { ListItemSeparator } from "../components/lists";
import navigationTheme from "../navigation/navigationTheme";
import routes from "../navigation/routes";


function PickerActionsScreen ( props ) {

    var type = 0
    var seedId = props.seedId
    var origin = props.origin
    var changeListing = props.changeListing

    const [modalVisible, setModalVisible] = useState(false);

   // const onPressPruebaType = changePruebaType()

    const selectInfoAction = async (type) => {
       console.log("saliendo de modal y yendo a AddAction con..... seedId: " + seedId +' origin: ' + props)
       //debugger
       setModalVisible(false)
    
       props.navigation.navigate(routes.ADD_ACTION, { type, seedId, origin, changeListing } ) 
    }

  
    return (
      <>
        <TouchableWithoutFeedback onPress={() => setModalVisible(true)}>
          <View style={styles.pickerStyle}>
            <AntDesign
              name="API"
              size={31}
              color= {colors.dark}
            />
          </View>
             </TouchableWithoutFeedback>
                <Modal style={styles.Modal} 
                       visible={modalVisible} 
                       transparent={true} 
                       backDropOpacity="0.8"
                       animationType="slide">
                    <View style={styles.Container} >                               
                 
                        <View style={styles.buttonsContainer}>
                            <AntDesign style={styles.button}
                                        name={"infocirlceo"}
                                        color={"grey"} size={27} 
                                        onPress={() => {
                                          type = 1
                                          selectInfoAction(type) 
                                        }}
                                         >
                                <Text style={styles.description}> +Info </Text>
                            </AntDesign>
                            <View style={styles.separator} /> 
                        </View> 
                        <View style={styles.buttonsContainer}>
                            <MaterialCommunityIcons style={styles.button}
                                            name={"lightbulb-on-outline"} 
                                            color={"grey"} size={30} 
                                            onPress={() => {
                                              type = 2
                                              selectInfoAction(type) 
                                            }}
                                             >
                                <Text style={styles.description}> +Idea </Text>
                            </MaterialCommunityIcons>   
                        </View> 
                        <View style={styles.buttonsContainer}>
                            <Fontisto style={styles.button} 
                                      name={"map"} 
                                      color={"grey"} 
                                      size={30}
                                      onPress={() => {
                                        type = 3
                                        selectInfoAction(type) 
                                      }}
                                        >
                                <Text style={styles.description}> +Plan </Text>
                            </Fontisto>
                        </View> 
                        <View style={styles.buttonsContainer}>
                            <FontAwesome5 style={styles.button} 
                                   name={"people-carry"}
                                   color={"grey"} size={30} 
                                   onPress={() => {
                                    type = 4
                                    selectInfoAction(type) 
                                  }} 
                                    >
                                <Text style={styles.description}> +Action </Text>
                            </FontAwesome5>  
                        </View> 
                        <View style={styles.buttonsContainer}>        
                            <Octicons style={styles.button}
                                     name={"megaphone"}  
                                     color={"grey"} 
                                     size={30} 
                                     onPress={() => {
                                      type = 5
                                      selectInfoAction(type) 
                                    }}
                                    >
                               <Text style={styles.description}> +Invite </Text>
                            </Octicons>  
                        </View> 
                        <View style={styles.buttonsContainer}>        
                            <FontAwesome5 style={styles.button} 
                                     name={"hat-wizard"} 
                                     color={"grey"} 
                                     size={30} 
                                     onPress={() => {
                                      type = 6
                                      selectInfoAction(type) 
                                    }}
                                    >
                             <Text style={styles.description}> +Play </Text>
                            </FontAwesome5 > 
                        </View> 
                        <View style={styles.buttonsContainer}>        
                            <Fontisto  style={styles.button} 
                                     name={"sourcetree"} 
                                     color={"grey"} 
                                     size={30} 
                                     onPress={() => {
                                      type = 7
                                      selectInfoAction(type) 
                                    }}
                                   >
                              <Text style={styles.description}> Branch </Text>
                            </Fontisto > 
                        </View>
                        <View style={styles.buttonsContainer}>        
                            <Entypo  style={styles.button} 
                                     name={"add-to-list"} 
                                     color={"grey"} 
                                     size={30} 
                                     onPress={() => {
                                      type = 8
                                      selectInfoAction(type) 
                                    }}
                                   >
                              <Text style={styles.description}> Requirement </Text>
                            </Entypo > 
                        </View> 
                        
                        <View style={styles.buttonsContainer}>        
                            <FontAwesome5  style={styles.button}
                                           name={"donate"} 
                                           color={"grey"} 
                                           size={30} 
                                           onPress={() => {
                                            type = 9
                                            selectInfoAction(type) 
                                          }} 
                                    >
                             <Text style={styles.description}> Donate </Text>
                            </FontAwesome5 > 
                            <ListItemSeparator/>
     
                       </View> 
                       <Button title="Cancel" onPress={() => setModalVisible(false)} color="secondary" /> 
          </View>
        </Modal>
      </>
    );
  }
  
  const styles = StyleSheet.create({
    pickerStyle: {
      marginTop: "5%",
      marginLeft: "6%",
      marginRight: "12%",
    },  
    Container: {
      paddingTop: "65%",
      marginBottom: "88%",
      marginLeft:"4.5%",
      width: "90%",
      marginVertical: 10,
      height: "50%",
      alignSelf: "baseline",
    },
    icon: {
      marginRight: 10,
    },
    placeholder: {
      color: defaultStyles.colors.medium,
      flex: 1,
    },
    text: {
      flex: 1,
    },
    readyButton: {
      //fontSize:4,
      marginTop: 8,
      width:"50%",
      borderRadius: 25,
      justifyContent: "center",
      alignItems: "center",
      padding: 15,
      marginVertical: 10,
    },
    buttonsContainer: {
        flexDirection: "row",
        //width: "90%",
    },
    Modal: {
        //backgroundColor: "blue",
    },
    button: {
      backgroundColor: colors.pistache,
      width: "95%",
      //height: "100%",
      padding: "2%",
      marginLeft: "3%",
    },
    separator: {
      width: "90%",
      height: 1,
      backgroundColor: colors.dark,
    },
  });
  
  export default PickerActionsScreen;
  

